import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

// by convention, composable function names start with "use"
export function useLearningOutcomeToggle() {
  const { t } = useI18n();
  const showLoName = ref(false); //use for cv-toggle's value
  const store = useStore();
  const isStudent = computed<boolean>(() => !!store.getters["auth/isStudent"]);

  function toggleLoName(value: boolean): void {
    showLoName.value = value;
  }

  const loNameToggleLabel = computed(() =>
    t("content_map_display_learning_outcome_view_toggle_label"),
  );

  const loNameToggleTooltip = computed(() =>
    t("content_map_display_learning_outcome_view_toggle_tooltip_message"),
  );

  const showLoNameOnly = computed(() => isStudent.value);

  // expose managed state as return value
  return {
    showLoName,
    toggleLoName,
    loNameToggleLabel,
    loNameToggleTooltip,
    showLoNameOnly,
  };
}
